import React, { createContext, useContext, useState, useEffect } from 'react';

const TestModeContext = createContext();

export const useTestMode = () => {
	const context = useContext(TestModeContext);
	if (!context) {
		throw new Error('useTestMode must be used within a TestModeProvider');
	}
	return context;
};

export const TestModeProvider = ({ children }) => {
	// Initialize from localStorage, default to false
	const [testMode, setTestMode] = useState(() => {
		const saved = localStorage.getItem('testMode');
		return saved === 'true';
	});

	// Persist to localStorage whenever it changes
	useEffect(() => {
		localStorage.setItem('testMode', testMode);
	}, [testMode]);

	const toggleTestMode = () => {
		setTestMode(prev => !prev);
	};

	const enableTestMode = () => {
		setTestMode(true);
	};

	const disableTestMode = () => {
		setTestMode(false);
	};

	const value = {
		testMode,
		toggleTestMode,
		enableTestMode,
		disableTestMode,
	};

	return (
		<TestModeContext.Provider value={value}>
			{children}
		</TestModeContext.Provider>
	);
};
